import React from 'react';
import { TypedMemo } from '../../common/types';
import { AiAssistantsConnect } from './aiAssistants/AiAssistantsConnect';
import { ConnectedAppsSection } from './aiAssistants/connectedApps/ConnectedAppsSection';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the AI assistants tab; each part uses its own slice of it */
import styles from './aiAssistants/aiAssistants.module.scss';
/* eslint-enable css-modules/no-unused-class */

/**
 * Settings → AI assistants (design: ai-assistants a1-a4): how to connect Claude, ChatGPT or another
 * MCP client, then the assistants that the user approved for the active workspace. It shows on
 * every plan: MCP works on every plan.
 */
const AiAssistantsTabComponent: React.FC = () => (
  <div className={styles.tab}>
    <AiAssistantsConnect />
    <ConnectedAppsSection />
  </div>
);

export const AiAssistantsTab = TypedMemo(AiAssistantsTabComponent);
